/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ProductsGet200ResponseInner model module.
 * @module model/ProductsGet200ResponseInner
 * @version 1.0.0
 */
class ProductsGet200ResponseInner {
    /**
     * Constructs a new <code>ProductsGet200ResponseInner</code>.
     * @alias module:model/ProductsGet200ResponseInner
     */
    constructor() { 
        
        ProductsGet200ResponseInner.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProductsGet200ResponseInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProductsGet200ResponseInner} obj Optional instance to populate.
     * @return {module:model/ProductsGet200ResponseInner} The populated <code>ProductsGet200ResponseInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProductsGet200ResponseInner();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('legacyId')) {
                obj['legacyId'] = ApiClient.convertToType(data['legacyId'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('price')) {
                obj['price'] = ApiClient.convertToType(data['price'], 'Number');
            }
            if (data.hasOwnProperty('costUnit')) {
                obj['costUnit'] = ApiClient.convertToType(data['costUnit'], 'String');
            }
            if (data.hasOwnProperty('currency')) {
                obj['currency'] = ApiClient.convertToType(data['currency'], 'String');
            }
            if (data.hasOwnProperty('validity')) {
                obj['validity'] = ApiClient.convertToType(data['validity'], 'String');
            }
            if (data.hasOwnProperty('validityUnit')) {
                obj['validityUnit'] = ApiClient.convertToType(data['validityUnit'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ProductsGet200ResponseInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ProductsGet200ResponseInner</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }
        // ensure the json data is a string
        if (data['legacyId'] && !(typeof data['legacyId'] === 'string' || data['legacyId'] instanceof String)) {
            throw new Error("Expected the field `legacyId` to be a primitive type in the JSON string but got " + data['legacyId']);
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['costUnit'] && !(typeof data['costUnit'] === 'string' || data['costUnit'] instanceof String)) {
            throw new Error("Expected the field `costUnit` to be a primitive type in the JSON string but got " + data['costUnit']);
        }
        // ensure the json data is a string
        if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
            throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
        }
        // ensure the json data is a string
        if (data['validity'] && !(typeof data['validity'] === 'string' || data['validity'] instanceof String)) {
            throw new Error("Expected the field `validity` to be a primitive type in the JSON string but got " + data['validity']);
        }
        // ensure the json data is a string
        if (data['validityUnit'] && !(typeof data['validityUnit'] === 'string' || data['validityUnit'] instanceof String)) {
            throw new Error("Expected the field `validityUnit` to be a primitive type in the JSON string but got " + data['validityUnit']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }

        return true;
    }


}



/**
 * The internal product ID
 * @member {String} id
 */
ProductsGet200ResponseInner.prototype['id'] = undefined;

/**
 * The legacy product ID
 * @member {String} legacyId
 */
ProductsGet200ResponseInner.prototype['legacyId'] = undefined;

/**
 * Name of the product
 * @member {String} name
 */
ProductsGet200ResponseInner.prototype['name'] = undefined;

/**
 * Upfront cost
 * @member {Number} price
 */
ProductsGet200ResponseInner.prototype['price'] = undefined;

/**
 * Unit of cost (e.g., EUR, USD)
 * @member {String} costUnit
 */
ProductsGet200ResponseInner.prototype['costUnit'] = undefined;

/**
 * Currency code (e.g., EUR)
 * @member {String} currency
 */
ProductsGet200ResponseInner.prototype['currency'] = undefined;

/**
 * Validity period (e.g., \"30 days\")
 * @member {String} validity
 */
ProductsGet200ResponseInner.prototype['validity'] = undefined;

/**
 * Validity period unit (e.g., \"days\", \"months\")
 * @member {String} validityUnit
 */
ProductsGet200ResponseInner.prototype['validityUnit'] = undefined;

/**
 * Description of the product
 * @member {String} description
 */
ProductsGet200ResponseInner.prototype['description'] = undefined;






export default ProductsGet200ResponseInner;

